(() => {
  const money = (cents) =>
      new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format((Number(cents) || 0) / 100),
    q = (root, selector) => (root ? root.querySelector(selector) : null),
    qa = (root, selector) =>
      root ? Array.from(root.querySelectorAll(selector)) : [],
    clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));

  function showToast(root, title, text) {
    const toast = q(root, "[data-m42-toast]");
    if (!toast) return;
    const titleEl = q(toast, "[data-m42-toast-title]"),
      textEl = q(toast, "[data-m42-toast-text]");
    (titleEl && (titleEl.textContent = title),
      textEl && (textEl.textContent = text),
      toast.classList.add("show"),
      clearTimeout(toast._m42Timer),
      (toast._m42Timer = setTimeout(
        () => toast.classList.remove("show"),
        3400,
      )));
  }
  function initHero(root) {
    const hero = q(root, "[data-m42-hero]");
    if (!hero || hero.dataset.m42Ready === "true") return;

    const mainImage = q(hero, "[data-m42-main-image]");
    const visual = q(hero, "[data-m42-main-visual]");

    qa(hero, "[data-m42-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        qa(hero, "[data-m42-thumb]").forEach((item) =>
          item.classList.remove("active"),
        );
        thumb.classList.add("active");
        const url = thumb.dataset.imageUrl;
        if (!mainImage || !url) return;
        mainImage.style.opacity = ".15";
        setTimeout(() => {
          mainImage.src = url;
          mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
          mainImage.style.opacity = "1";
        }, 150);
      });
    });

    if (
      visual &&
      mainImage &&
      window.matchMedia("(pointer:fine)").matches
    ) {
      visual.addEventListener("pointermove", (event) => {
        const rect = visual.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        mainImage.style.transform =
          `scale(1.06) translate(${x * -14}px, ${y * -10}px)`;
      });
      visual.addEventListener("pointerleave", () => {
        mainImage.style.transform = "scale(1)";
      });
    }

    const form = q(hero, ".m42-product-form");
    const variantsScript = q(root, "[data-m42-variants]");
    const optionsScript = q(root, "[data-m42-option-names]");
    if (!form || !variantsScript || !optionsScript) return;

    let variants = [];
    let optionNames = [];
    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
      optionNames = JSON.parse(optionsScript.textContent || "[]");
    } catch (error) {
      console.error("Emerald 35 variant data could not be read.", error);
      return;
    }

    if (!Array.isArray(variants) || !variants.length) {
      console.error("Emerald 35 has no readable Shopify variants.");
      return;
    }

    const normalise = (value) => String(value ?? "").trim();
    const numericMetres = (value) => {
      const match = normalise(value).match(/[\d.]+/);
      return match ? Number(match[0]) : 0;
    };
    const sameOption = (left, right) =>
      normalise(left) === normalise(right);

    const detectedWidthIndex = optionNames.findIndex((name) =>
      normalise(name).toLowerCase().includes("width"),
    );
    const detectedLengthIndex = optionNames.findIndex((name) =>
      normalise(name).toLowerCase().includes("length"),
    );
    const widthIndex = detectedWidthIndex >= 0 ? detectedWidthIndex : 0;
    const lengthIndex =
      detectedLengthIndex >= 0
        ? detectedLengthIndex
        : Math.min(1, Math.max(0, optionNames.length - 1));

    const widthButtons = qa(hero, "[data-m42-width]");
    const lengthSelect = q(hero, "[data-m42-length]");
    const variantInput = q(form, 'input[name="id"]');
    const quantityInput = q(form, 'input[name="quantity"]');
    const quantityOutput = q(hero, "[data-m42-qty-output]");
    const addButton = q(form, "[data-m42-add]");

    if (
      !widthButtons.length ||
      !lengthSelect ||
      !variantInput ||
      !quantityInput
    ) {
      return;
    }

    /*
      SHOPIFY NATIVE PURCHASE PROCESS:
      Shopify's live product.variants JSON is the single source of truth.
      There is deliberately NO product-specific maximum length in JavaScript.
      A 20m product exposes the variants Shopify gives it; a 25m product exposes
      its 25m variants without any code change.
    */
    const variantWidthValues = [
      ...new Set(
        variants
          .map((variant) =>
            normalise(variant.options?.[widthIndex]),
          )
          .filter(Boolean),
      ),
    ].sort((a, b) => numericMetres(a) - numericMetres(b));

    widthButtons.forEach((button) => {
      const currentValue = normalise(button.dataset.optionValue);
      const currentNumber = numericMetres(
        currentValue || button.textContent,
      );
      const exact = variantWidthValues.find((value) =>
        sameOption(value, currentValue),
      );
      const numericMatch = variantWidthValues.find(
        (value) => numericMetres(value) === currentNumber,
      );
      const resolved = exact || numericMatch;
      if (resolved) button.dataset.optionValue = resolved;
    });

    let activeWidthButton = widthButtons.find((button) =>
      button.classList.contains("active"),
    );
    if (
      !activeWidthButton ||
      !variantWidthValues.some((value) =>
        sameOption(value, activeWidthButton.dataset.optionValue),
      )
    ) {
      activeWidthButton =
        widthButtons.find(
          (button) => numericMetres(button.dataset.optionValue) === 4,
        ) || widthButtons[0];
    }
    widthButtons.forEach((button) =>
      button.classList.toggle("active", button === activeWidthButton),
    );

    let quantity = Math.max(1, Number(quantityInput.value || 1));
    let preferredLengthNumber =
      numericMetres(lengthSelect.value) || 1;

    function selectedWidth() {
      return normalise(
        widthButtons.find((button) =>
          button.classList.contains("active"),
        )?.dataset.optionValue,
      );
    }

    function availableLengthValues(widthValue) {
      const values = variants
        .filter((variant) =>
          sameOption(variant.options?.[widthIndex], widthValue),
        )
        .map((variant) =>
          normalise(variant.options?.[lengthIndex]),
        )
        .filter(
          (value) => value && numericMetres(value) > 0,
        );

      return [...new Set(values)].sort(
        (a, b) => numericMetres(a) - numericMetres(b),
      );
    }

    function rebuildLengthOptions(
      preferredNumber = preferredLengthNumber,
    ) {
      const lengths = availableLengthValues(selectedWidth());
      const previousValue = normalise(lengthSelect.value);

      lengthSelect.innerHTML = "";

      lengths.forEach((value) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        option.style.setProperty(
          "background-color",
          "#ffffff",
          "important",
        );
        option.style.setProperty("color", "#111111", "important");
        option.style.setProperty(
          "-webkit-text-fill-color",
          "#111111",
          "important",
        );
        lengthSelect.appendChild(option);
      });

      const exactPrevious = lengths.find((value) =>
        sameOption(value, previousValue),
      );
      const preferred = lengths.find(
        (value) => numericMetres(value) === preferredNumber,
      );

      lengthSelect.value =
        exactPrevious || preferred || lengths[0] || "";
      preferredLengthNumber =
        numericMetres(lengthSelect.value) || preferredLengthNumber;

      return lengths;
    }

    function selectedLength() {
      return normalise(lengthSelect.value);
    }

    function findVariant() {
      const width = selectedWidth();
      const length = selectedLength();

      return (
        variants.find((variant) => {
          const options = variant.options || [];
          return (
            sameOption(options[widthIndex], width) &&
            sameOption(options[lengthIndex], length)
          );
        }) || null
      );
    }

    function updateOrder() {
      const variant = findVariant();
      const width = numericMetres(selectedWidth());
      const length = numericMetres(selectedLength());
      const area = width * length;
      const totalArea = area * quantity;
      const totalPrice = variant
        ? Number(variant.price) * quantity
        : 0;

      variantInput.value = variant?.id || "";
      quantityInput.value = String(quantity);
      if (quantityOutput) {
        quantityOutput.textContent = String(quantity);
      }

      const pieceSize = q(hero, "[data-m42-piece-size]");
      const pieceArea = q(hero, "[data-m42-piece-area]");
      const totalAreaEl = q(hero, "[data-m42-total-area]");
      const totalPriceEl = q(hero, "[data-m42-total-price]");
      const buttonPrice = q(hero, "[data-m42-button-price]");

      if (pieceSize) {
        pieceSize.textContent = `${width}m × ${length}m`;
      }
      if (pieceArea) pieceArea.textContent = `${area}m²`;
      if (totalAreaEl) {
        totalAreaEl.textContent = `${totalArea}m²`;
      }
      if (totalPriceEl) {
        totalPriceEl.textContent = money(totalPrice);
      }
      if (buttonPrice) {
        buttonPrice.textContent = money(totalPrice);
      }

      const available = Boolean(variant && variant.available);
      if (addButton) {
        addButton.disabled = !available;
        addButton.setAttribute(
          "aria-disabled",
          String(!available),
        );
      }
    }

    widthButtons.forEach((button) => {
      button.addEventListener("click", () => {
        widthButtons.forEach((item) =>
          item.classList.remove("active"),
        );
        button.classList.add("active");
        rebuildLengthOptions(preferredLengthNumber);
        updateOrder();
      });
    });

    lengthSelect.addEventListener("change", () => {
      preferredLengthNumber =
        numericMetres(lengthSelect.value) ||
        preferredLengthNumber;
      updateOrder();
    });

    q(hero, "[data-m42-qty-minus]")?.addEventListener(
      "click",
      () => {
        quantity = Math.max(1, quantity - 1);
        updateOrder();
      },
    );

    q(hero, "[data-m42-qty-plus]")?.addEventListener(
      "click",
      () => {
        quantity = Math.min(99, quantity + 1);
        updateOrder();
      },
    );

        /*
      ADD TO CART

      Emerald 35 prepares the exact Shopify variant and quantity first.
      Rosyz then handles the actual submission using its native AjaxCart.
    */

    form.addEventListener(
      "submit",
      () => {
        const variant = findVariant();

        if (!variant || !variant.available) {
          return;
        }

        variantInput.value = String(variant.id);
        quantityInput.value = String(quantity);
      }
    );

    const attachRosyzAjaxCart = () => {
      if (
        form.dataset.emerald35AjaxCartReady === "true"
      ) {
        return true;
      }

      if (
        !window.jQuery ||
        typeof window.AjaxCart !== "function"
      ) {
        return false;
      }

      try {
        new window.AjaxCart(
          window.jQuery(form)
        );

        form.dataset.emerald35AjaxCartReady =
          "true";

        return true;
      } catch (error) {
        console.error(
          "Emerald 35 AjaxCart could not initialise.",
          error
        );

        return false;
      }
    };

    if (!attachRosyzAjaxCart()) {
      let ajaxCartAttempts = 0;

      const ajaxCartTimer =
        window.setInterval(() => {
          ajaxCartAttempts += 1;

          if (
            attachRosyzAjaxCart() ||
            ajaxCartAttempts >= 50
          ) {
            window.clearInterval(
              ajaxCartTimer
            );
          }
        }, 100);
    }

    rebuildLengthOptions(preferredLengthNumber);
    updateOrder();

    /*
      Mark ready only after Shopify variant data and purchase controls
      have been successfully initialised. This mirrors the Premium pages
      and allows the existing retry boot to recover from early theme hydration.
    */
    hero.dataset.m42Ready = "true";
  }

  function initCompare(root) {
    qa(root, "[data-m42-compare]").forEach((compare) => {
      if (compare.dataset.m42Ready === "true") return;
      compare.dataset.m42Ready = "true";
      const range = q(compare, 'input[type="range"]');
      range?.addEventListener("input", () =>
        compare.style.setProperty("--pos", `${range.value}%`),
      );
    });
  }
  function initReveal(root) {
    const items = qa(root, ".reveal:not([data-m42-reveal-ready])");
    if (!items.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting &&
            (entry.target.classList.add("visible"),
            observer.unobserve(entry.target));
        });
      },
      { threshold: 0.1 },
    );
    items.forEach((item) => {
      ((item.dataset.m42RevealReady = "true"), observer.observe(item));
    });
  }
  function initLayer(root) {
    qa(root, "[data-m42-layer-section]").forEach((section) => {
      if (section.dataset.m42Ready === "true") return;
      section.dataset.m42Ready = "true";
      const video = q(
        section,
        "video.m42-layer-video, video[data-m42-layer-video]",
      );
      if (!video) return;
      const phase = q(section, "[data-m42-layer-phase]"),
        detail = q(section, "[data-m42-layer-detail]"),
        fill = q(section, "[data-m42-layer-fill]"),
        dot = q(section, "[data-m42-layer-dot]");
      let duration = 10,
        target = 0,
        ready = !1,
        rafQueued = !1;
      function copy(progress) {
        const phaseText =
            progress < 0.12
              ? "Complete product"
              : progress < 0.43
                ? "Separating construction"
                : progress < 0.72
                  ? "Construction layers revealed"
                  : progress < 0.94
                    ? "Recombining product"
                    : "Complete product",
          detailText =
            progress < 0.12
              ? "Scroll to begin separating the Emerald 35 construction."
              : progress < 0.43
                ? "The backing components move apart into clearly labelled positions."
                : progress < 0.72
                  ? "Primary Backing, Geotextile Grid and PU and/or Latex coating are clearly revealed."
                  : progress < 0.94
                    ? "Continue scrolling as the construction returns to the finished product."
                    : "Emerald 35 is complete and ready for the next section.";
        (phase && (phase.textContent = phaseText),
          detail && (detail.textContent = detailText),
          fill && (fill.style.height = `${progress * 100}%`),
          dot && (dot.style.top = `${progress * 100}%`));
      }
      function onScroll() {
        const rect = section.getBoundingClientRect(),
          travel = Math.max(1, section.offsetHeight - innerHeight),
          progress = clamp(-rect.top / travel);
        ((target = progress * Math.max(0.01, duration - 0.04)), copy(progress));
      }
      function tick() {
        if (ready && Number.isFinite(video.duration)) {
          const difference = target - video.currentTime;
          Math.abs(difference) > 0.018 &&
            (video.currentTime += difference * 0.34);
        }
        requestAnimationFrame(tick);
      }
      function prepare() {
        ((duration = Number.isFinite(video.duration) ? video.duration : 10),
          (ready = !0),
          video.pause(),
          onScroll());
      }
      (video.addEventListener("loadedmetadata", prepare, { once: !0 }),
        video.addEventListener(
          "canplay",
          () => {
            ((ready = !0), video.pause());
          },
          { once: !0 },
        ),
        video.readyState >= 1 && prepare(),
        addEventListener(
          "scroll",
          () => {
            rafQueued ||
              (requestAnimationFrame(() => {
                (onScroll(), (rafQueued = !1));
              }),
              (rafQueued = !0));
          },
          { passive: !0 },
        ),
        addEventListener("resize", onScroll, { passive: !0 }),
        onScroll(),
        requestAnimationFrame(tick));
    });
  }
  function initCoolTabs(root) {
    qa(root, "[data-m42-cool]").forEach((section) => {
      if (section.dataset.m42Ready === "true") return;
      section.dataset.m42Ready = "true";
      const visual = q(section, "[data-m42-cool-visual]"),
        buttons = qa(section, "[data-m42-cool-mode]");
      function setMode(mode) {
        (buttons.forEach((item) => {
          const active = item.dataset.m42CoolMode === mode;
          (item.classList.toggle("active", active),
            item.setAttribute("aria-selected", String(active)));
        }),
          visual && (visual.dataset.mode = mode),
          qa(section, ".m42-gc-panel video").forEach((video) => {
            video
              .closest(".m42-gc-panel")
              ?.classList.contains(
                mode === "drain" ? "m42-gc-water" : "m42-gc-uv",
              )
              ? video.play().catch(() => {})
              : video.pause();
          }));
      }
      (buttons.forEach((button) =>
        button.addEventListener("click", () =>
          setMode(button.dataset.m42CoolMode),
        ),
      ),
        setMode(
          visual?.dataset.mode || buttons[0]?.dataset.m42CoolMode || "heat",
        ));
    });
  }
  function initTriweave(root) {
    qa(root, "[data-m42-triweave]").forEach((section) => {
      if (section.dataset.m42Ready === "true") return;
      section.dataset.m42Ready = "true";
      const stage = q(section, "[data-m42-blade-stage]"),
        title = q(section, "[data-m42-focus-title]");
      qa(section, "[data-m42-blade]").forEach((button) => {
        button.addEventListener("click", () => {
          (qa(section, "[data-m42-blade]").forEach((item) =>
            item.classList.remove("active"),
          ),
            button.classList.add("active"),
            stage && (stage.dataset.active = button.dataset.m42Blade),
            title && (title.textContent = button.dataset.title || ""));
        });
      });
    });
  }
  function initSpecs(root) {
    qa(root, "[data-m42-specs]").forEach((section) => {
      if (section.dataset.m42Ready === "true") return;
      section.dataset.m42Ready = "true";
      const buttons = qa(section, "[data-m42-spec-tab]"),
        panels = qa(section, "[data-m42-spec-panel]");
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const tab = button.dataset.m42SpecTab;
          (buttons.forEach((item) =>
            item.classList.toggle("active", item === button),
          ),
            panels.forEach((panel) => {
              const active = panel.dataset.m42SpecPanel === tab;
              ((panel.hidden = !active),
                active &&
                  panel.animate &&
                  panel.animate(
                    [
                      { opacity: 0.25, transform: "translateY(8px)" },
                      { opacity: 1, transform: "none" },
                    ],
                    { duration: 260 },
                  ));
            }));
        });
      });
    });
  }
  function initFaq(root) {
    qa(root, "[data-m42-faq-item]").forEach((item) => {
      if (item.dataset.m42Ready === "true") return;
      item.dataset.m42Ready = "true";
      const button = q(item, "[data-m42-faq-question]"),
        answer = q(item, ".faq-a");
      function setOpen(open) {
        (item.classList.toggle("open", open),
          button?.setAttribute("aria-expanded", String(open)),
          answer &&
            (answer.style.maxHeight = open
              ? `${answer.scrollHeight}px`
              : "0px"));
      }
      (button?.addEventListener("click", () =>
        setOpen(!item.classList.contains("open")),
      ),
        setOpen(item.classList.contains("open")),
        addEventListener(
          "resize",
          () => {
            item.classList.contains("open") &&
              answer &&
              (answer.style.maxHeight = `${answer.scrollHeight}px`);
          },
          { passive: !0 },
        ));
    });
  }
  function initBackToBuy(root) {
    qa(root, "[data-m42-back-to-buy]").forEach((button) => {
      button.dataset.m42Ready !== "true" &&
        ((button.dataset.m42Ready = "true"),
        button.addEventListener("click", (event) => {
          (button.tagName === "A" &&
            button.getAttribute("href") &&
            button.getAttribute("href") !== "#top") ||
            (event.preventDefault(),
            document
              .querySelector("[data-m42-hero]")
              ?.scrollIntoView({ behavior: "smooth", block: "start" }));
        }));
    });
  }
  function init(root = document) {
    qa(root, ".m42-page").forEach((page) => {
      (initHero(page),
        initCompare(page),
        initReveal(page),
        initLayer(page),
        initCoolTabs(page),
        initTriweave(page),
        initSpecs(page),
        initFaq(page),
        initBackToBuy(page));
    });
  }
  const boot = () => init();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
  [80, 250, 700].forEach((delay) => setTimeout(boot, delay));
  window.addEventListener("pageshow", boot);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();

